import { type RefObject, useEffect, useState } from 'react';

const INTERSECTION_THRESHOLD = 0.3;

export function useSpiderWebIntersectionVisibility(
	containerRef: RefObject<HTMLDivElement | null>,
	replayOnVisible: boolean,
): boolean {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const el = containerRef.current;
		if (!el) {
			return;
		}

		const options: IntersectionObserverInit = {
			threshold: INTERSECTION_THRESHOLD,
		};

		if (!replayOnVisible) {
			const observer = new IntersectionObserver(([entry]: IntersectionObserverEntry[]) => {
				if (entry?.isIntersecting) {
					setIsVisible(true);
					observer.disconnect();
				}
			}, options);
			observer.observe(el);
			return () => observer.disconnect();
		}

		const observer = new IntersectionObserver(([entry]: IntersectionObserverEntry[]) => {
			if (entry) {
				setIsVisible(entry.isIntersecting);
			}
		}, options);
		observer.observe(el);
		return () => observer.disconnect();
	}, [containerRef, replayOnVisible]);

	return isVisible;
}
